import { FormSwitch, Select } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { IncomingInvoicePaymentRunFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";

/** The options of a payment file: Skonto, and the pain.001 version the bank software imports. */
export function IncomingInvoicePaymentRunForm() {
	/** Context */
	const methods = useFormContext<IncomingInvoicePaymentRunFormSchema>();

	/** Hooks */
	const { t } = useTranslation();

	/** Computed */
	const formatOptions = [
		{ value: "pain.001.001.09", label: t("incoming_invoices.payments.format_09"), item: null },
		{ value: "pain.001.001.03", label: t("incoming_invoices.payments.format_03"), item: null },
	];

	/** Render */
	return (
		<div className="v-stack gap-4">
			<div className="v-stack gap-1">
				<FormSwitch
					control={methods.control}
					name="isSkontoApplied"
					data-cy="payment-run-skonto-switch"
				>
					{t("incoming_invoices.payments.apply_skonto")}
				</FormSwitch>
			</div>
			<Select
				control={methods.control}
				name="format"
				label={t("incoming_invoices.payments.format")}
				isRequired
				isNullable={false}
				options={formatOptions}
				data-cy="payment-run-format-select"
			/>
		</div>
	);
}
